import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RechazarOrdenPage } from './rechazar-orden.page';

const routes: Routes = [
  {
    path: '',
    component: RechazarOrdenPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RechazarOrdenPageRoutingModule {}
